const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('core', 'extensions/afrux-forum-widgets-core/common/components/Widget');